import { render, staticRenderFns } from "./LeadsGrid.vue?vue&type=template&id=956a3784&scoped=true"
import script from "./LeadsGrid.vue?vue&type=script&lang=ts"
export * from "./LeadsGrid.vue?vue&type=script&lang=ts"
import style0 from "./LeadsGrid.vue?vue&type=style&index=0&id=956a3784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956a3784",
  null
  
)

export default component.exports